import { getAsync } from '../helpers/apiRequest'
import { IBodyRequestModel } from '../models/api/IBodyRequestModel'
import { TokenExpiryWrapper } from './TokenManager'

export type IStorageRequest = IBodyRequestModel

export interface IStorageResponse {
  success: boolean
  message?: string
  // eslint-disable-next-line
  data?: any
}

export const projectFilesList = TokenExpiryWrapper(
  async (request: IStorageRequest): Promise<IStorageResponse> => {
    const url = `/storage/list/project`
    return await getAsync(url, request)
  },
  [],
  null,
)

export const bulkFilesList = TokenExpiryWrapper(
  async (request: IStorageRequest): Promise<IStorageResponse> => {
    const url = `/storage/list/bulk-update`
    return await getAsync(url, request)
  },
  [],
  null,
)
